import { Library } from "../types/downloadTypes"

// Fallback to free libraries if backend function downloadLinksGet fails
// To easily update this harcoded data, can run that function via Postman using a free current user in request body
export const freeLibraries: Library = {
  sample: {
    downloadId: "6JRXkzzLUqLqIaf8oOzyh",
    title: "Free Sample 4.0",
    version: 4,
    startDate: new Date("2021-10-26T15:00:00.000Z"),
    lastUpdated: new Date("2021-10-26T11:00-04:00"),
    link: "https://www.dropbox.com/sh/p5ym69ddi7rjes7/AACJnxRDVCDuEfU8LyvOImZza?dl=1",
    isFree: true,
    category: "mockup",
  },
  plugin: {
    downloadId: "54zAj3dQWx0KWUJetR0aV4",
    title: "Free Plugin",
    version: 3,
    startDate: new Date("2020-02-28T05:00:00.000Z"),
    lastUpdated: new Date("2020-02-28T00:00-05:00"),
    link: "https://www.dropbox.com/s/0s2bnvjiv6u4005/download%20Angle%20Free%20%281%29.zip?dl=1",
    isFree: true,
    category: "plugin",
  },
  wallpaper: {
    downloadId: "717eozvo4Prg4wpmzhNBaD",
    title: "Free Wallpaper",
    version: 3,
    startDate: new Date("2020-02-28T05:00:00.000Z"),
    lastUpdated: new Date("2020-02-28T00:00-05:00"),
    link: "https://www.dropbox.com/s/vlzap37hl081ff1/Free%20Wallpaper%20Sample.zip?dl=1",
    isFree: true,
    category: "wallpaper",
  },
}

export const proLibrariesFallback: Library = {
  sketch: {
    downloadId: "1TcXsQp37RLQ67hcZlpPGH",
    title: "Pro Sketch 4.6",
    version: 4,
    startDate: new Date("2023-09-25T00:00-04:00"),
    lastUpdated: new Date("2023-09-25T00:00-04:00"),
    link: "https://firebasestorage.googleapis.com/v0/b/anglesh.appspot.com/o/account-downloads%2F2023-09-25%20Package%20-%20Sketch.zip?alt=media&token=42f57018-ae77-4784-b825-bd4fc264491b",
    isFree: false,
    category: "mockup",
    designTool: "Sketch",
  },
  figma: {
    downloadId: "7biCMUPrm7uiV22y23nwPB",
    title: "Pro Figma 4.7",
    version: 4,
    startDate: new Date("2024-11-26T00:00-04:00"),
    lastUpdated: new Date("2024-11-26T00:00-04:00"),
    link: "https://firebasestorage.googleapis.com/v0/b/anglesh.appspot.com/o/account-downloads%2F2024-11-26%20Package%20-%20Figma.zip?alt=media&token=9147a579-54fa-470d-a11e-80da611c2875",
    isFree: false,
    category: "mockup",
    designTool: "Figma",
  },
  xd: {
    downloadId: "3NeyIbdzmvumAVbgNDzIin",
    title: "Pro XD 4.6",
    version: 4,
    startDate: new Date("2023-09-25T00:00-04:00"),
    lastUpdated: new Date("2023-09-25T00:00-04:00"),
    link: "https://firebasestorage.googleapis.com/v0/b/anglesh.appspot.com/o/account-downloads%2F2023-09-25%20Package%20-%20XD.zip?alt=media&token=52676cfa-b174-4824-831b-b8b6a9f42928",
    isFree: false,
    category: "mockup",
    designTool: "Adobe XD",
  },
  wallpaper: {
    downloadId: "01j0lNzOb6syjwlB7ApLC6",
    title: "Pro Wallpaper 1.3",
    version: 3,
    startDate: new Date("2022-10-17T00:00-04:00"),
    lastUpdated: new Date("2022-10-17T00:00-04:00"),
    link: "https://firebasestorage.googleapis.com/v0/b/anglesh.appspot.com/o/account-downloads%2Fdownload%20Wallpapers(2021-10-29).zip?alt=media&token=6ba63519-08bc-4a3c-88a8-677ba0d0183c",
    isFree: false,
    category: "wallpaper",
  },
}
